export class SetIgnoreAskForPushUntilAction {
  static readonly type = '[Notifications] Set Ignore Ask For Push Until';
  constructor(public ignoreUntil: Date) {}
}

export class AskForPushAction {
  static readonly type = '[Notifications] Ask For Push';
  constructor(public ignoreSnooze = false) {}
}

export class EnablePushNotificationsAction {
  static readonly type = '[Notifications] Enable Push Notifications';
}
